import { createHandlerChainRunnerOptionalParameter, Handler } from "@insite/client-framework/HandlerCreator";

type HandlerType = Handler<{}, {}>;

export const DispatchResetWishLists: HandlerType = props => {
    props.dispatch({
        type: "Data/WishLists/Reset",
    });
};

export const chain = [DispatchResetWishLists];

const resetWishLists = createHandlerChainRunnerOptionalParameter(chain, {}, "ResetWishLists");

export default resetWishLists;
